module.exports = __webpack_public_path__ + "h5/img/shen.24d80ec2.jpg";